import { Deserializable } from '../../protocols/deserializable';
import { EmploymentTypeEnum } from '../../employers/enum/employment-type.enum';
import { EmploymentStatusType } from '../../employers/employer-history/types/employment-status-type';
import { EmploymentStatusTypeId } from '../../employers/enum/employment-status-type-id';

export class EmployeeTableUserEmploymentHistory implements Deserializable {
  public id!: number;
  public memberId!: number;
  public workFromHome!: boolean;
  public startDate!: string;
  public endDate!: string | null;
  public contributionStartDate!: string;
  public lastExpectedContributionDate!: string | null;
  public onLeave!: boolean;
  public employmentTypeId!: EmploymentTypeEnum;
  public employmentStatusId!: EmploymentStatusTypeId;
  public employmentStatus!: EmploymentStatusType;

  public onDeserialize(): void {}
}
